import { createFileRoute } from '@tanstack/react-router';

import { AuthGuard } from '@/features/auth/guards/auth-guard';
import { Layout } from '@/layout/main-layout';

export const Route = createFileRoute('/_layout')({
  component: RootLayout,
});

function RootLayout() {
  return (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  );
}
